import {
  CHECK_CART_STATUS_START,
  CHECK_CART_STATUS_SUCCESS,
  CHECK_CART_STATUS_ERROR,
  ADD_TO_CART_START,
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_ERROR,
  BOOKING_SUMMARY_FOR_CART_START,
  BOOKING_SUMMARY_FOR_CART_SUCCESS,
  BOOKING_SUMMARY_FOR_CART_ERROR,
  SAVE_RIDER_START,
  SAVE_RIDER_SUCCESS,
  SAVE_RIDER_ERROR,
  TOUR_ORDER_SUCCESS_DETAILS_START,
  TOUR_ORDER_SUCCESS_DETAILS_SUCCESS,
  TOUR_ORDER_SUCCESS_DETAILS_ERROR,
} from "../Constant/TourBookingConstant";

const initialState = {
  loading: false,
  data: [],
  booking_summary: [],
  cartStatus :[],
  orderSuccessDetails:null
};

export default function TourBookingReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case ADD_TO_CART_START:
    case CHECK_CART_STATUS_START:
      return {
        ...state,
        loading: true,
      };
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case ADD_TO_CART_ERROR:
    case CHECK_CART_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case CHECK_CART_STATUS_SUCCESS :
      return {
        ...state,
        cartStatus:action.payload,
        loading: false,
      }
    case BOOKING_SUMMARY_FOR_CART_START:
      return {
        ...state,
        booking_summary: [],
        loading: true,
      };
    case BOOKING_SUMMARY_FOR_CART_SUCCESS:
      return {
        ...state,
        booking_summary: action.payload,
        loading: false,
      };
    case BOOKING_SUMMARY_FOR_CART_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
      case TOUR_ORDER_SUCCESS_DETAILS_START:
        return {
          ...state,
          loading: true,
        };
      case TOUR_ORDER_SUCCESS_DETAILS_SUCCESS:
        return {
          ...state,
          orderSuccessDetails: action.payload,
          loading: false,
        };
      case TOUR_ORDER_SUCCESS_DETAILS_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
    default:
      return state;
  }
}
